import { formatMonthKey, parsePublishedAt, monthKey as toMonthKey } from './galleryFilters';

export function anchorIdForMonth(monthKey) {
  return `gallery-anchor-${monthKey}`;
}

export function itemMonthKey(item) {
  const p = parsePublishedAt(item.publishedAt);
  return p ? toMonthKey(p.year, p.month) : null;
}

/**
 * Build grid rows: month headers + cards (newest-first feed).
 */
export function buildGalleryGridRows(visibleItems) {
  const rows = [];
  let lastMonth = null;

  for (const item of visibleItems) {
    const mk = itemMonthKey(item);
    if (mk && mk !== lastMonth) {
      rows.push({ type: 'anchor', monthKey: mk, label: formatMonthKey(mk) });
      lastMonth = mk;
    }
    rows.push({ type: 'card', item });
  }

  return rows;
}

export function scrollToMonthAnchor(monthKey, behavior = 'smooth') {
  const el = document.getElementById(anchorIdForMonth(monthKey));
  if (!el) return false;
  el.scrollIntoView({ behavior, block: 'start' });
  return true;
}

export function findStartIndexForMonth(monthAnchors, monthKey) {
  if (!Array.isArray(monthAnchors)) return 0;
  const hit = monthAnchors.find((a) => a.monthKey === monthKey);
  return hit && typeof hit.startIndex === 'number' ? hit.startIndex : 0;
}
